"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _striptags = _interopRequireDefault(require("striptags"));

var _htmlEntities = require("html-entities");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var entities = new _htmlEntities.AllHtmlEntities();
/**
 * Strip tags and replace double spaces with the single one
 */

var _default = function _default(text) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$keepImageAltText = _ref.keepImageAltText,
      keepImageAltText = _ref$keepImageAltText === void 0 ? true : _ref$keepImageAltText,
      _ref$keepTextStyle = _ref.keepTextStyle,
      keepTextStyle = _ref$keepTextStyle === void 0 ? false : _ref$keepTextStyle;

  // Check if text is a WYSIWYG object
  if (_typeof(text) === 'object' && Object.prototype.hasOwnProperty.call(text, 'content') && typeof text.content === 'string') {
    text = text.content;
  }

  if (keepImageAltText) {
    text = text.replace(/<img[^>]*alt=["'“”]([^"'“”]*?)["'“”][^>]*>/g, ' $1');
  }

  var allowedTags = [];

  if (keepTextStyle) {
    allowedTags.push('strong');
    allowedTags.push('span');
  }

  text = (0, _striptags.default)(text, allowedTags);
  text = entities.decode(text);
  return text.trim().replace(/\s\s+/g, ' ');
};

exports.default = _default;